// extracted by mini-css-extract-plugin
export var barContainer = "_5w-0";
export var extraThin = "_5w-3";
export var fillBar = "_5w-6";
export var fillContainer = "_5w-4";
export var overflow = "_5w-8";
export var overflowContainer = "_5w-5";
export var regular = "_5w-7";
export var thick = "_5w-1";
export var thin = "_5w-2";